import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Table } from "@/features/Table";
import { type C3DataUpload, data_upload_columns } from "./columns";
import UploadPopover from "@/components/UploadPopover";
import { type FilterC3DataUploadSchema, C3DataUploadFilter } from "./filter";
import { C3DataUploadNew } from "./new";
import { useQueryClient } from "@tanstack/react-query";
import { Clients } from "@/lib/clients";
import { ClientTables } from "@/lib/clientTables";

export const C3DataUploadTable = () => {
  const [searchParams] = useSearchParams();
  const [files, setFiles] = useState<File[]>([]);
  const [selectedConfig, setSelectedConfig] = useState<string | null>(null);
  const client = searchParams.get("client") || Clients.C3;

  const QueryClient = useQueryClient();
  const refreshList = async () => {
    // In v5, this invalidates all queries whose key starts with the prefix
    await QueryClient.invalidateQueries({
      queryKey: [client, ClientTables.C3_DATA_UPLOAD, "get"],
    });
  };

  return (
    <Table<C3DataUpload, FilterC3DataUploadSchema>
      label="Chargement de fichiers"
      client={client}
      table_name={ClientTables.C3_DATA_UPLOAD}
      columns={data_upload_columns}
      filter={<C3DataUploadFilter />}
      disable_translations_request={true}
      new_item={
        <UploadPopover
          uploader={({ setIsOpen }) => (
            <C3DataUploadNew
              setIsOpen={setIsOpen}
              files={files}
              setFiles={setFiles}
              selectedConfig={selectedConfig}
              setSelectedConfig={setSelectedConfig}
              onSuccess={async () => {
                await refreshList();
              }}
            />
          )}
        />
      }
    />
  );
};
